import { createElement, useRef, useState, useEffect } from "react";
import { ElementFactory, Question, Serializer, SvgRegistry } from "survey-core";
import {
    SurveyQuestionElementBase,
    ReactQuestionFactory
} from "survey-react-ui";
import ReactDOMServer from "react-dom/server";
import { Button } from "@mui/material";
import { Camera } from "react-camera-pro";
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CameraIcon from '@mui/icons-material/Camera';
import moment from "moment";
import { getAPI } from "../api/getApi";

const CUSTOM_TYPE = "camera";

// A model for the new question type
export class QuestionCameraModel extends Question {
    getType() {
        return CUSTOM_TYPE;
    }
    //   get colorPickerType() {
    //     return this.getPropertyValue("colorPickerType");
    //   }
    //   set colorPickerType(val) {
    //     this.setPropertyValue("colorPickerType", val);
    //   }

    //   get disableAlpha() {
    //     return this.getPropertyValue("disableAlpha");
    //   }
    //   set disableAlpha(val) {
    //     this.setPropertyValue("disableAlpha", val);
    //   }
}

// Register `QuestionColorPickerModel` as a model for the `color-picker` type
export function registerCamera() {
    ElementFactory.Instance.registerElement(CUSTOM_TYPE, (name) => {
        return new QuestionCameraModel(name);
    });
}

// Specify display names for the question type and its properties
// const locale = localization.getLocale("");
// locale.qt[CUSTOM_TYPE] = "camera";
// locale.pe.colorPickerType = "Color picker type";
// locale.pe.disableAlpha = "Disable alpha channel";

// Register an SVG icon for the question type
const svg = ReactDOMServer.renderToString();
SvgRegistry.registerIconFromSvg(CUSTOM_TYPE, svg);

// Add question type metadata for further serialization into JSON
Serializer.addClass(
    CUSTOM_TYPE,
    [
        // {
        //   name: "colorPickerType",
        //   default: "Slider",
        //   choices: ["Slider", "Sketch", "Compact"],
        //   category: "general",
        //   visibleIndex: 2 // After the Name and Title
        // },
        // {
        //   name: "disableAlpha:boolean",
        //   dependsOn: "colorPickerType",
        //   visibleIf: function (obj) {
        //     return obj.colorPickerType === "Sketch";
        //   },
        //   category: "general",
        //   visibleIndex: 3 // After the Name, Title, and Color Picker type
        // }
    ],
    function () {
        return new QuestionCameraModel("");
    },
    "question"
);

// A class that renders questions of the new type in the UI
export class SurveyQuestionCamera extends SurveyQuestionElementBase {

    constructor(props) {
        super(props);
        // console.log(props.question.propertyHash?.value, 'props');
        this.state = { value: this.question.value };
    }
    get question() {
        return this.questionBase;
    }
    get value() {
        // console.log(this.question.value, 'value');   
        return this.question.value;
    }
    get disableAlpha() {
        return this.question.disableAlpha;
    }
    get type() {
        return this.question.colorPickerType;
    }
    handleColorChange = (data) => {
        this.question.value = data;
    };

    // Support the read-only and design modes
    get style() {
        return this.question.getPropertyValue("readOnly") ||
            this.question.isDesignMode
            ? { pointerEvents: "none" }
            : undefined;
    }

    renderElement() {
        return <CameraQuestion handleChange={this.handleColorChange} value={this.question.value} />
    }
}

// Register `SurveyQuestionColorPicker` as a class that renders `color-picker` questions
ReactQuestionFactory.Instance.registerQuestion(CUSTOM_TYPE, (props) => {
    return createElement(SurveyQuestionCamera, props);
});

// Register the `color-picker` as an editor for properties of the `color` type in the Survey Creator's Property Grid
// PropertyGridEditorCollection.register({
//     fit: function (prop) {
//         return prop.type === "color";
//     },
//     getJSON: function () {
//         return {
//             type: CUSTOM_TYPE,
//             colorPickerType: "Compact"
//         };
//     }
// });

// const toBase64 = file => new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = () => resolve(reader.result);
//     reader.onerror = reject;
// });

function addTimestampToImage(base64Image) {
    return new Promise((resolve, reject) => {
        // Create a new image object to load the base64 image
        const image = new Image();
        image.src = base64Image;

        // When the image is loaded, draw it on a canvas and add the timestamp
        image.onload = () => {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');

            // Set canvas dimensions to match the image
            canvas.width = image.width;
            canvas.height = image.height;

            // Draw the image on the canvas
            context.drawImage(image, 0, 0);

            // Set font style and text color for the timestamp
            context.font = '20px Arial';
            context.fontWeight = 900;
            context.fillStyle = '#F9B61F';
            context.textAlign = 'right';

            // Get the current timestamp
            const timestamp = new Date().toLocaleString();

            // Add the timestamp in the bottom-right corner
            context.fillText(timestamp, canvas.width - 10, canvas.height - 10);

            // Convert the canvas back to a base64 image
            const updatedBase64Image = canvas.toDataURL('image/png');
            resolve(updatedBase64Image);
        };

        image.onerror = (err) => {
            reject(err);
        };
    });
}

export function CameraQuestion({ handleChange, value }) {

    const camera = useRef(null);
    const [image, setImage] = useState(null);
    const [start, setStart] = useState(true);
    console.log(value, 'value', value || null);
    const onCapture = async () => {
        console.log("photo", camera.current.takePhoto());
        const random = Math.floor(Math.random() * 90 + 10)
        // const base64 = await toBase64()
        console.log(camera.current.takePhoto());
        const updatedBase64Image = await addTimestampToImage(camera.current.takePhoto())
        // console.log(updatedBase64Image, 'img');
        const [, variable] = updatedBase64Image.split(',')
        const file_name = random + '_gogas_img-' + moment().format('DD/MM/YYYY hh:mm:ss a').replace(/[^a-zA-Z0-9.]/g, "_")
            .replace(/\s+/g, "_") + ".png";
        setImage(updatedBase64Image);
        const vari = {
            "filename": file_name,
            "file": variable
        }
        const res = await getAPI("https://2ofd7a6iv2hv6a3jlyz5mwxazu0udszw.lambda-url.ap-south-1.on.aws/", vari)
        // console.log(res?.data?.result?.Location, 'res');
        if (res.data.success) {
            handleChange(res?.data?.result?.Location)
        } else {
            setStart(true)
        }
    };

    useEffect(() => {
        if (value) {
            setImage(value)
            setStart(false)
        }
    }, [value])

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                height: 300,
                justifyContent: 'center'
            }}
        >
            {/* {console.log(start)} */}
            {start && !image && <Button variant="contained" style={{ backgroundColor: '#F9B61F', gap: 8, minWidth: 100, cursor: 'pointer', border: 0, padding: 12, borderRadius: 8, fontSize: 16, color: '#4F3084', fontWeight: 'bold', display: 'inline-flex', alignItems: 'center' }}
                onClick={() => setStart(false)}><CameraAltIcon /> Take photo</Button>}
            {!start &&
                <>
                    <div style={{ height: 250, width: 300, position: "relative" }}>
                        {!image && <Camera ref={camera} facingMode="environment" />}
                        {image && (
                            <img
                                src={image}
                                alt="Taken photo"
                                style={{
                                    height: 250,
                                    width: 300,
                                    objectFit: "cover",
                                }}
                            />
                        )}
                    </div>
                    {!image && (
                        <Button variant="contained" style={{ marginTop: 16, gap: 8, minWidth: 100, cursor: 'pointer', border: 0, padding: 12, borderRadius: 8, fontSize: 16, color: '#fff', fontWeight: 'bold', display: 'inline-flex', alignItems: 'center' }}
                            onClick={onCapture}>
                            <CameraIcon />
                            Capture
                        </Button>
                    )}
                    {image && (
                        <Button variant="contained" style={{ marginTop: 16, gap: 8, minWidth: 100, cursor: 'pointer', border: 0, padding: 12, borderRadius: 8, fontSize: 16, color: '#fff', fontWeight: 'bold', display: 'inline-flex', alignItems: 'center' }}
                            onClick={() => setImage(null)}>
                            <CameraIcon />
                            Retake
                        </Button>
                    )}
                </>
            }
        </div>
    );
}